/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Button, Divider, FormControl, InputLabel, MenuItem, TextField, Typography, Select, CircularProgress } from "@mui/material";
import Listboxes from "../ListBoxes/ListBoxes";
import customHttp from "../../services/customHTTP";
import AccordianLists from "../AccordianLists/AccordianLists";
import Swal from "sweetalert2";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
const EditUserForm = ({
	allCustomers,
	allSites,
	selectedUser,
	setSelectedUser,
	setAllUsers,
	allUsers,
	assignedSitesLoc,
	setAssignedSitesLoc,
}) => {
	const [userEditSubmit, setUserEditSubmit] = useState(false);
	const [assignedSitesLoc1, setAssignedSitesLoc1] = useState([]);
	const [userSubmitLoading, setUserSubmitLoading] = useState(false);
	const [error, setError] = useState("");
	const [submitIsLoading, setSubmitIsLoading] = useState(false);
	const [submitIsSuccess, setSubmitIsSuccess] = useState(false);

	const handleAssignedSitesLocChange = (updatedAssignedSites) => {
		setAssignedSitesLoc1((prevAssignedSites) => {
			// Check if the new assigned sites are the same as the previous state
			if (JSON.stringify(prevAssignedSites) !== JSON.stringify(updatedAssignedSites)) {
				return updatedAssignedSites;
			}
			// If they're the same, return the previous state (no update needed)
			return prevAssignedSites;
		});
	};

	const handleUserEditCancel = (e) => {
		setSelectedUser(null);
	};

	const handleUserEditSubmit = (e) => {
		e.preventDefault();
		// Handle the form submission (update user logic)
		// Step 1: Extract the customer and sites into a string
		const customers = assignedSitesLoc1.map((item) => item.customer).join(",");
		const sites = assignedSitesLoc1.flatMap((item) => item.sites).join(",");

		// Step 2: Update selectedUser with the new values
		const updatedUser = {
			...selectedUser,
			user_customers: customers,
			user_sites: sites,
		};

		setSelectedUser(updatedUser);
		setUserEditSubmit(true);
	};

	useEffect(() => {
		const updateUser = async () => {
			try {
				const { user_id, created, updated, ...userWithoutIdCreatedUpdated } = selectedUser;

				const req_body = {
					userId: user_id,
					data: userWithoutIdCreatedUpdated,
				};

				const response = await customHttp.post("/users/update", req_body);
				if (response.data.status === "success") {
					selectedUser.user_display_name = `${selectedUser.user_first_name} ${selectedUser.user_last_name}`;
					setAllUsers((prevUsers) =>
						prevUsers.map((user) =>
							user.user_id === selectedUser.user_id ? { ...user, ...selectedUser } : user
						)
					);
					console.log(selectedUser);
					setSubmitIsSuccess(true);
					await Swal.fire({
						icon: "success",
						title: "Success",
						text: "User Successfully Updated.",
					});
					setSubmitIsSuccess(false);
					// Update allUsers state with the updated user
				} else {
					setError("Failed to Update User: No user found.");
				}
			} catch (err) {
				setError("Failed to Update User: " + err.message);
			} finally {
				setUserSubmitLoading(false);
				setSubmitIsLoading(false);
				
				setUserEditSubmit(false);
				setSelectedUser(null);
			}
		};

		if (userEditSubmit) {
			setUserSubmitLoading(true);
			setSubmitIsLoading(true);
			updateUser();
			
		}
	}, [userEditSubmit]);

	return (
		<>
			{selectedUser && (
				<>
					{/* <Divider sx={{ my: 2 }} /> */}
					<div className="user-edit-form">
						<Typography variant="h6" gutterBottom>
							Edit User
						</Typography>
						<div className="edit-user-form">
							<div className="user-details-section">
								<form>
									<Divider>User Details</Divider>
									<div className="form-group">
										<TextField
											label="First Name"
											variant="outlined"
											fullWidth
											size="small"
											margin="normal"
											value={selectedUser.user_first_name || ""}
											onChange={(e) =>
												setSelectedUser({
													...selectedUser,
													user_first_name: e.target.value,
												})
											}
										/>
										<TextField
											label="Last Name"
											variant="outlined"
											fullWidth
											size="small"
											margin="normal"
											value={selectedUser.user_last_name || ""}
											onChange={(e) =>
												setSelectedUser({
													...selectedUser,
													user_last_name: e.target.value,
												})
											}
										/>

										<TextField
											label="Email"
											variant="outlined"
											fullWidth
											size="small"
											margin="normal"
											value={selectedUser.user_email || ""}
											onChange={(e) =>
												setSelectedUser({
													...selectedUser,
													user_email: e.target.value,
												})
											}
										/>
									</div>
									<div className="form-group">
										<TextField
											label="Phone"
											variant="outlined"
											fullWidth
											size="small"
											margin="normal"
											value={selectedUser.user_phone || ""}
											onChange={(e) =>
												setSelectedUser({
													...selectedUser,
													user_phone: e.target.value,
												})
											}
										/>
										<FormControl variant="outlined" fullWidth size="small" margin="normal">
											<InputLabel>Role</InputLabel>
											<Select
												label="Role"
												value={selectedUser.user_role || ""}
												onChange={(e) =>
													setSelectedUser({
														...selectedUser,
														user_role: e.target.value,
													})
												}>
												<MenuItem value="Admin">Admin</MenuItem>
												<MenuItem value="Viewer">Viewer</MenuItem>
												<MenuItem value="Purchaser">Purchaser</MenuItem>
											</Select>
										</FormControl>

										<FormControl variant="outlined" fullWidth size="small" margin="normal">
											<InputLabel>Status</InputLabel>
											<Select
												label="Status"
												value={selectedUser.user_status || "0"}
												onChange={(e) =>
													setSelectedUser({
														...selectedUser,
														user_status: e.target.value,
													})
												}>
												<MenuItem value="1">Approved</MenuItem>
												<MenuItem value="0">Pending</MenuItem>
											</Select>
										</FormControl>
									</div>
								</form>
							</div>
							<Divider>Customer Allocation</Divider>
							<div className="user-customer-section">
								<Listboxes
									sites={allSites}
									customers={allCustomers}
									assignedSitesProp={assignedSitesLoc}
									onAssignedSitesChange={handleAssignedSitesLocChange}
								/>
							</div>
						</div>
						<div className="button-container">
							<Button
								variant="contained"
								color="primary"
								type="submit"
								onClick={handleUserEditSubmit}
								disabled={!(assignedSitesLoc1.length > 0 && selectedUser.user_status !== undefined)}
								sx={{ mt: 2 }}>
								{submitIsLoading ? (
									<>
										<CircularProgress size={16} sx={{ color: "white", marginRight: 1 }} />
										Saving...
									</>
								) : submitIsSuccess ? (
									<>
										<CheckCircleIcon sx={{ color: "white", marginRight: 1 }} />
										Saved
									</>
								) : (
									"Save Changes"
								)}
							</Button>
							<Button variant="outlined" color="primary" onClick={handleUserEditCancel} sx={{ mt: 2 }}>
								Cancel
							</Button>
						</div>
					</div>
				</>
			)}
		</>
	);
};

export default EditUserForm;
